"use client"

import { CounterBadge } from "@/app/nft/counter/badge"
import type { QueryResponse } from "@/app/nft/search/result/utils"
import { reatomComponent } from "@reatom/react"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { ProfileListingsMoleculeReatom } from "../store.reatom"

export const ListingsCounterReatom = reatomComponent(() => {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <ListingsCounterBadgeReatom />
      </Suspense>
    </ErrorBoundary>
  )
}, "ListingsCounterReatom")

const ListingsCounterBadgeReatom = reatomComponent(() => {
  const { queryParamsAtom } = useMolecule(ProfileListingsMoleculeReatom)
  // Call atom directly in Reatom v1000
  const queryParams = queryParamsAtom()
  const { data } = useSuspenseInfiniteQuery(queryParams)
  const [page] = data.pages as [QueryResponse]
  const count = page.totalNftsCount

  return <CounterBadge count={count} />
}, "ListingsCounterBadgeReatom")
